module.exports = __webpack_public_path__ + "static/media/MileMarkerDinner.702aecce.pdf";